import React, { useState, useEffect, FunctionComponent, CSSProperties } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailHeadingProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const [backgroundStyle, setBackgroundStyle] = useState<CSSProperties>({});

  useEffect(() => {
    const url = props.coverImg || props.coverNoImg;
    setBackgroundStyle({ backgroundImage: `url(${url})` });
  }, [props.coverImg, props.coverNoImg]);

  return (
    <Presentation
      {...props}
      backgroundStyle={backgroundStyle}
    />
  );
};
